import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { all_routes } from "./router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaShoppingCart } from "react-icons/fa";
import axios from "axios";
import { ProductContext } from "../context/AppContext";
import { SocketContext } from "../context/socketContext";
import Swal from "sweetalert2";
import { Modal, Button, Spinner } from "react-bootstrap";

const notificationModules = [
  { id: 8, label: "Communication" },
  { id: 7, label: "Time Table" },
  { id: 9, label: "Transport" },
  { id: 11, label: "MANAGEMENT" },
  { id: 12, label: "HRM" },
  { id: 3, label: "Visitor" },
];

function SidebarHeader({ quantities = {}, handleCartClick = () => { } }) {
  const routes = all_routes;
  const {
    userData,
    setuserData,
    getenquiry,
    getRegistration,
    fetchUserProfileData,
    getMenuList,
    StudentProfileData,
    Automationdata,
    Dashboarddata,
    GetstudentData
  } = useContext(ProductContext);
  const { notificationlist = [], requestBrowserNotificationPermission } = useContext(SocketContext) || {};
  const hasNotificationAlert = notificationlist.some((item) => !item?.seen);


  const navigation = useNavigate();
  const authtoken = localStorage.getItem("token");
  const location = useLocation();


  const [getCheckMaster, setCheckMaster] = useState(null);
  const [error, setError] = useState(null);
  const [siblingAccounts, setSiblingAccounts] = useState([]);
  const [activeSiblingUser, setActiveSiblingUser] = useState(
    typeof window !== "undefined" ? localStorage.getItem("activeUser") || "" : ""
  );
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const accountSwitchRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);

  // -----------------------------
  // Extract enquiry & class data
  // -----------------------------
  const EnquiryData = getenquiry?.data?.length > 0 ? getenquiry?.data[0] : null;
  const ClassId = EnquiryData?.class;

  const safeValue = (val) => (val && val !== "null" ? val : null);
  const FatherMobile = safeValue(EnquiryData?.contactno);
  const MotherMobile = safeValue(EnquiryData?.mother_contact_no);
  const GuardianMobile = safeValue(EnquiryData?.guardian_mobile_no);
  const MobileNumber = FatherMobile || MotherMobile || GuardianMobile;

  // -----------------------------
  // Fetch Class Master Info (like RN)
  // -----------------------------
  useEffect(() => {
    const fetchCheckMasterData = async () => {
      try {
        const response = await axios.get(
          `https://api.mirai.healthcare/api/masters/classes/${ClassId}`,
          {
            headers: {
              "x-auth": authtoken,
              "Content-Type": "application/json",
            },
          }
        );
        setCheckMaster(response?.data);
      } catch (err) {
        console.error("API error Class Master:", err);
        setError(err);
        if (err.response && err.response.status === 401) {
          console.log("Navigate to login due to 401");
          navigation(routes.login);
        }
      }
    };
    if (ClassId && authtoken) fetchCheckMasterData();
  }, [ClassId, authtoken]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const storedSiblings =
        JSON.parse(localStorage.getItem("siblings")) || [];
      setSiblingAccounts(storedSiblings);
    } catch (err) {
      console.error("Error parsing sibling accounts:", err);
      setSiblingAccounts([]);
    }
    setActiveSiblingUser(localStorage.getItem("activeUser") || "");
  }, []);

  useEffect(() => {
    const updateView = () => {
      if (typeof window === "undefined") return;
      setIsMobileView(window.innerWidth <= 768);
    };
    updateView();
    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountSwitchRef.current && !accountSwitchRef.current.contains(event.target)) {
        setIsAccountDropdownOpen(false);
      }
      if (
        notificationDropdownRef.current &&
        !notificationDropdownRef.current.contains(event.target)
      ) {
        setIsNotificationDropdownOpen(false);
      }
    };
    if (isAccountDropdownOpen || isNotificationDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isAccountDropdownOpen, isNotificationDropdownOpen]);

  // -----------------------------
  // Registration Logic
  // -----------------------------
  const isRegistered = getRegistration?.data
    ? Object.values(getRegistration?.data).length > 0
    : false;


  const filteredMenuList =
    (isRegistered
      ? getRegistration?.data?.admission_marked_status
        ? getMenuList
        : getMenuList?.filter((item) => item.visible_after >= 2)
      : getMenuList?.filter((item) => item.visible_after >= 3)) || [];

  // STEP 2: Add registration fee condition
  const isEntranceExamAllowed =
    getRegistration?.data?.registration_fee_status !== "unpaid";

  // STEP 3: Process menu list
  const processedMenuList = filteredMenuList
    // Filter Entrance Exam
    .filter((item) => {
      if (GetstudentData?.admission_num) {
        if (
          item?.label === "Entrance Exam" ||
          item?.label === "Registration"
        ) {
          return false; // ❌ hide
        }
      }

      if (item?.label === "Entrance Exam") {
        // Entrance exam must ALSO depend on fee status
        return (
          isEntranceExamAllowed && // <—— NEW CONDITION
          getCheckMaster?.data?.is_entrance_required !== false
        );
      }
      return true;
    })

    // Filter submenu items


    // Sort alphabetically
    .slice()
    .sort((a, b) => {
      if (a.label === "Remove Account") return 1;
      if (b.label === "Remove Account") return -1;
      return a.label?.localeCompare(b.label);
    });

  const handleLogout = () => {
    try {
      // Clear browser localStorage
      localStorage.clear();
      localStorage.removeItem('token');
      localStorage.removeItem('siblings');

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "LOGOUT"
          })
        );
      }

      // Redirect to login page
      window.location.href = '/login';
    } catch (e) {
      console.error("Logout Error:", e);
    }
  };

  const handleRemoveAccount = () => {
    setShowRemoveModal(true);
  };

  const confirmRemoveAccount = async () => {
    setRemoveLoading(true);
    try {
      const response = await axios.put(
        "https://api.mirai.healthcare/api/student-details/student-status/activate-student-delete-user",
        {},
        { headers: { "x-auth": authtoken } }
      );

      if (response.data?.success || response.status === 200) {
        setShowRemoveModal(false);
        Swal.fire({
          title: "Account Removed",
          text: "Your account has been successfully removed.",
          icon: "success",
          confirmButtonColor: "#3085d6"
        }).then(() => {
          handleLogout();
        });
      } else {
        Swal.fire("Error", response.data?.message || "Failed to remove account", "error");
      }
    } catch (error) {
      console.error("Remove account error:", error);
      Swal.fire("Error", "Something went wrong while removing the account.", "error");
    } finally {
      setRemoveLoading(false);
    }
  };

  const isDueFeeLocked = Dashboarddata?.data?.due_fee?.is_show_due_fee === true;
  const handleRestrictedClick = (event) => {
    if (isDueFeeLocked) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const handleAccountSwitchClick = (event) => {
    if (isDueFeeLocked) {
      handleRestrictedClick(event);
      return;
    }
    if (isMobileView || siblingAccounts.length === 0) {
      navigation(routes.accountswitch);
      return;
    }
    event.preventDefault();
    setIsAccountDropdownOpen((prev) => !prev);
  };

  const handleNotificationClick = (event) => {
    if (isDueFeeLocked) {
      handleRestrictedClick(event);
      return;
    }
    event.preventDefault();
    setIsAccountDropdownOpen(false);
    if (typeof requestBrowserNotificationPermission === "function" && typeof window !== "undefined") {
      requestBrowserNotificationPermission().then((permission) => {
        if (permission === "denied") {
          Swal.fire({
            icon: "warning",
            title: "Notifications blocked",
            text: "Browser notifications are blocked. Please allow notifications in browser settings.",
          });
          return;
        }
        setIsNotificationDropdownOpen((prev) => !prev);
      });
      return;
    }
    setIsNotificationDropdownOpen((prev) => !prev);
  };

  const handleNotificationModuleClick = (moduleId) => {
    setIsNotificationDropdownOpen(false);
    navigation(`${routes.notificationModuleWise}/${moduleId}`);
  };

  const handleAccountSelection = (sibling) => {
    if (!sibling?.token) {
      Swal.fire({
        icon: "error",
        title: "Unable to switch account",
        text: "Selected account is missing credentials.",
      });
      return;
    }
    localStorage.setItem("token", sibling.token);
    localStorage.setItem("activeUser", sibling.username);
    localStorage.setItem("full_name", sibling.full_name);
    setActiveSiblingUser(sibling.username);
    setIsAccountDropdownOpen(false);
    Swal.fire({
      icon: "success",
      title: "Switched account",
      text: `${sibling.full_name} (${sibling.username})`,
      timer: 1500,
      showConfirmButton: false,
    }).then(() => {
      window.location.href = "/";
    });
  };

  const dummyProfileImage = GetstudentData?.upload_photo?.link;

  const profileImage =
    StudentProfileData?.student_image?.trim() ||
    StudentProfileData?.profile_image?.trim() ||
    userData?.currentUser?.profileImage?.trim();

  const ProfilePhoto = dummyProfileImage || profileImage;
  // dummyProfileImage;

  const displayName =
    userData?.currentUser?.full_name ||
    userData?.currentUser?.username ||
    "User Name";
  const formatRole = (role) => {
    if (!role) return null;
    if (typeof role === "string") {
      return role.replace(/_/g, " ");
    }
    if (Array.isArray(role)) {
      return role.join(", ").replace(/_/g, " ");
    }
    return String(role);
  };
  const displayRole = formatRole(userData?.currentUser?.accounttype) || "Guardian";
  const displayEmail =
    userData?.currentUser?.email || "Email not shared";
  const displayId =
    userData?.currentUser?.id ||
    userData?.currentUser?.username ||
    "N/A";
  const classLabel = StudentProfileData?.class_name
    ? `${StudentProfileData?.class_name}${StudentProfileData?.section_name
      ? ` - ${StudentProfileData?.section_name}`
      : ""
    }`
    : null;
  const guardianNames = [
    safeValue(StudentProfileData?.father_full_name),
    safeValue(StudentProfileData?.mother_full_name),
    safeValue(StudentProfileData?.guardian_name),
  ]
    .filter(Boolean)
    .join(", ");
  const admissionStatusLabel = getRegistration?.data?.pri_application_status;

  const profileHighlights = [
    { label: "Student ID", value: displayId },
    classLabel ? { label: "Class", value: classLabel } : null,
    guardianNames
      ? { label: "Guardian", value: guardianNames }
      : null,
  ].filter((item) => item?.value);

  const contactDetails = [
    displayEmail ? { icon: "ti ti-mail", value: displayEmail } : null,
    MobileNumber
      ? { icon: "ti ti-device-mobile", value: MobileNumber }
      : null,
  ].filter(Boolean);


  return (
    <div className="header">
      <div className="header-left active">
        <Link
          to={routes.index}
          className="logo logo-normal"
          onClick={isDueFeeLocked ? handleRestrictedClick : undefined}
          style={isDueFeeLocked ? { opacity: 0.7, cursor: "not-allowed" } : undefined}
        >
          <img src={Automationdata?.data?.[0]?.schoolLogo} style={{ width: "55%", textAlign: "left", float: "left" }} />
          {/* <ImageWithBasePath src="assets/img/logo.webp" alt="Logo" /> */}
        </Link>

      </div>

      {authtoken && isMobileView && (
        <div
          className="mobile-notification-center position-absolute"
          ref={notificationDropdownRef}
          style={{
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1055,
          }}
        >
          <button
            type="button"
            className={`btn btn-outline-primary d-flex align-items-center justify-content-center notification-bell-btn${hasNotificationAlert ? " has-alert" : ""}${isDueFeeLocked ? " disabled" : ""}`}
            title="Notifications"
            aria-label="Notifications"
            onClick={handleNotificationClick}
            style={{
              width: "42px",
              height: "42px",
              padding: 0,
              borderRadius: "50%",
              ...(isDueFeeLocked ? { pointerEvents: "auto", opacity: 0.7, cursor: "not-allowed" } : {})
            }}
          >
            <span className="notification-bell-icon-wrap">
              <i className="ti ti-bell-ringing fs-5" />
              {hasNotificationAlert && <span className="notification-bell-dot" />}
            </span>
          </button>
          {isNotificationDropdownOpen && (
            <div
              className="notification-module-dropdown shadow border bg-white rounded-4"
              style={{
                position: "absolute",
                top: "50px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "360px",
                maxWidth: "90vw",
                zIndex: 1055,
              }}
            >
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="fw-semibold text-dark">Notifications</span>
                  <Link
                    to={routes.notification}
                    className="small text-primary text-decoration-none"
                    onClick={() => setIsNotificationDropdownOpen(false)}
                  >
                    View All
                  </Link>
                </div>
                <small className="text-muted">Choose a module</small>
              </div>
              <div className="p-3">
                <div className="row g-2">
                  {notificationModules.map((module) => (
                    <div className="col-6" key={module.id}>
                      <button
                        type="button"
                        className="w-100 text-start border rounded-3 px-3 py-2 bg-light"
                        onClick={() => handleNotificationModuleClick(module.id)}
                        style={{ transition: "all 0.2s ease" }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="small fw-semibold text-dark">{module.label}</span>
                          <i className="ti ti-chevron-right text-muted" />
                        </div>
                        {notificationlist?.some((item) =>
                          !item?.seen &&
                          Number(item?.module_id ?? item?.moduleId ?? item?.module) === module.id
                        ) && (
                            <span className="badge bg-danger mt-2">
                              New
                            </span>
                          )}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="header-user">
        <div className="nav user-menu">

          <div className="d-flex align-items-center ms-auto">
            {authtoken ? (
              <>
                {!isMobileView && (
                  <div className="pe-1 position-relative" ref={notificationDropdownRef}>
                    <button
                      type="button"
                      className={`btn btn-outline-primary d-flex align-items-center justify-content-center me-2 notification-bell-btn${hasNotificationAlert ? " has-alert" : ""}${isDueFeeLocked ? " disabled" : ""}`}
                      title="Notifications"
                      aria-label="Notifications"
                      onClick={handleNotificationClick}
                      style={{
                        width: "48px",
                        height: "48px",
                        padding: 0,
                        borderRadius: "50%",
                        ...(isDueFeeLocked ? { pointerEvents: "auto", opacity: 0.7, cursor: "not-allowed" } : {})
                      }}
                    >
                      <span className="notification-bell-icon-wrap">
                        <i className="ti ti-bell-ringing fs-4" />
                        {hasNotificationAlert && <span className="notification-bell-dot" />}
                      </span>
                    </button>
                    {isNotificationDropdownOpen && (
                      <div
                        className="notification-module-dropdown shadow border bg-white rounded-4"
                        style={{
                          position: "absolute",
                          top: "58px",
                          right: 0,
                          width: "360px",
                          maxWidth: "90vw",
                          zIndex: 1050,
                        }}
                      >
                        <div className="p-3 border-bottom">
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="fw-semibold text-dark">Notifications</span>

                          </div>
                          <small className="text-muted">Choose a module</small>
                        </div>
                        <div className="p-3">
                          <div className="row g-2">
                            {notificationModules.map((module) => (
                              <div className="col-6" key={module.id}>
                                <button
                                  type="button"
                                  className="w-100 text-start border rounded-3 px-3 py-2 bg-light"
                                  onClick={() => handleNotificationModuleClick(module.id)}
                                  style={{ transition: "all 0.2s ease" }}
                                >
                                  <div className="d-flex align-items-center justify-content-between">
                                    <span className="small fw-semibold text-dark">{module.label}</span>
                                    <i className="ti ti-chevron-right text-muted" />
                                  </div>
                                  {notificationlist?.some((item) =>
                                    !item?.seen &&
                                    Number(item?.module_id ?? item?.moduleId ?? item?.module) === module.id
                                  ) && (
                                      <span className="badge bg-danger mt-2">
                                        New
                                      </span>
                                    )}
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="pe-1 account-switch-entry" ref={accountSwitchRef}>
                  <button
                    type="button"
                    className={`btn btn-primary d-flex align-items-center me-3${isDueFeeLocked ? " disabled" : ""}`}
                    id="btnAccountSwitch"
                    onClick={handleAccountSwitchClick}
                    style={
                      isDueFeeLocked
                        ? { pointerEvents: "auto", opacity: 0.7, cursor: "not-allowed" }
                        : undefined
                    }
                  >
                    Account Switch
                  </button>
                  {isAccountDropdownOpen && (
                    <div className="account-switch-dropdown shadow border bg-white rounded-3">
                      <div className="account-switch-header d-flex align-items-center justify-content-between mb-2">
                        <span className="fw-semibold text-dark">Choose Account</span>

                      </div>
                      {siblingAccounts && siblingAccounts.length > 0 ? (
                        <div className="account-switch-list">
                          {siblingAccounts.map((sibling) => {
                            const isActive = sibling.username === activeSiblingUser;
                            return (
                              <button
                                type="button"
                                key={`${sibling.username}-${sibling.full_name}`}
                                className={`account-switch-option w-100 text-start ${isActive ? "active" : ""
                                  }`}
                                onClick={() => handleAccountSelection(sibling)}
                              >
                                <span className="d-block fw-semibold text-dark">
                                  {sibling.full_name || "Unnamed"}
                                </span>
                                <small className="text-muted d-block">
                                  {sibling.username}
                                  {isActive ? " · Current" : ""}
                                </small>
                              </button>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="text-muted small">
                          No other accounts available. Tap Manage to add/switch.
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div
                  className="dropdown ms-1"
                  style={isDueFeeLocked ? { pointerEvents: "auto" } : undefined}
                >
                  <Link
                    to="#"
                    className="dropdown-toggle d-flex align-items-center btn btn-primary d-flex"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="avatar avatar-sm me-2 online avatar-rounded">
                      {/* <ImageWithBasePath
                        src="assets/img/profiles/avatar-27.jpg"
                        alt="Profile"
                        className="rounded-circle"
                      /> */}
                      <img
                        src={ProfilePhoto || "assets/img/student.jfif"}
                        alt="Profile"
                        className="rounded-circle"
                      />

                    </span>

                    Profile
                  </Link>
                  <div
                    className="dropdown-menu dropdown-menu-end shadow-lg border-0 p-0"
                    style={{
                      minWidth: "300px",
                      maxWidth: "350px",
                      maxHeight: "80vh",
                      overflowY: "auto",
                      borderRadius: "12px"
                    }}
                  >
                    {/* User Profile Card */}


                    {/* Menu Items */}
                    <div className="p-3">
                      {processedMenuList.map((menulist, index) => {
                        const firstSubItem = menulist?.submenuItems?.[0] || menulist?.submenuItems;

                        const resolveRoute = (app_link) => {
                          if (
                            typeof app_link === "string" &&
                            app_link.startsWith("routes.")
                          ) {
                            return app_link.replace("routes.", "");
                          }
                          return app_link;
                        };

                        const directRoute = firstSubItem?.app_link
                          ? routes[resolveRoute(firstSubItem.app_link)]
                          : null;
                        const targetRoute = directRoute || routes.information;

                        const isRemoveAccount = menulist.label === "Remove Account";

                        return (
                          <Link
                            key={index}
                            className={`dropdown-item px-3 py-3 rounded mb-2 d-flex align-items-center text-decoration-none${isDueFeeLocked ? " disabled opacity-50" : ""}`}
                            to={isRemoveAccount ? "#" : (
                              menulist?.submenuItems?.length === 1
                                ? targetRoute
                                : routes.information
                            )}
                            state={{
                              id: menulist.id,
                              label: menulist.label,
                              submenuItems: menulist.submenuItems,
                            }}
                            onClick={(e) => {
                              if (isDueFeeLocked) {
                                handleRestrictedClick(e);
                              } else if (isRemoveAccount) {
                                e.preventDefault();
                                handleRemoveAccount();
                              }
                            }}
                            style={isDueFeeLocked ? { cursor: "not-allowed" } : {
                              transition: "all 0.2s ease",
                              borderLeft: "3px solid transparent",
                              color: isRemoveAccount ? "#dc3545" : "inherit"
                            }}
                            title={menulist.label}
                          >
                            <i className={`${menulist.icon || 'ti ti-trash'} me-3 fs-4 opacity-75`} style={{ width: "24px", minWidth: "24px", color: isRemoveAccount ? "#dc3545" : "inherit" }} />
                            <span className="flex-grow-1">{menulist.label}</span>
                            <i className="ti ti-chevron-right text-muted ms-auto" style={{ fontSize: "1.1rem" }} />
                          </Link>
                        );
                      })}
                    </div>

                    {/* Separator and Logout */}
                    <div className="dropdown-divider my-0"></div>
                    <Link
                      className="dropdown-item px-3 py-3 text-danger d-flex align-items-center rounded-bottom"
                      to=""
                      onClick={handleLogout}
                      style={{
                        borderRadius: "0 0 12px 12px",
                        transition: "background-color 0.2s ease"
                      }}
                      title="Sign Out"
                    >
                      <i className="ti ti-logout me-3 fs-4" style={{ width: "24px", minWidth: "24px" }} />
                      <span>Logout</span>
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="pe-1">
                  <Link
                    //   onClick={toggleFullscreen}
                    to={routes.createenquiry}
                    className="btn btn-primary d-flex align-items-center me-3"
                    id="btnFullscreen"
                  >
                    Enquiry
                  </Link>
                </div>

                <div className="pe-1">
                  <Link
                    //   onClick={toggleFullscreen}
                    to={routes.login}
                    className="btn btn-primary d-flex align-items-center me-3"
                    id="btnFullscreen"
                  >
                    Login
                  </Link>
                </div>
              </>
            )}

          </div>
        </div>
      </div>


      {/* Remove Account Custom Modal */}
      <Modal show={showRemoveModal} onHide={() => !removeLoading && setShowRemoveModal(false)} centered>
        <Modal.Header closeButton={!removeLoading}>
          <Modal.Title className="text-danger d-flex align-items-center">
            <i className="ti ti-alert-triangle me-2 fs-3"></i> Remove Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="alert alert-danger mb-0">
            <strong>Warning:</strong> You will not be able to log in again after this. To regain access, you will need to contact the school administration.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-2" onClick={() => setShowRemoveModal(false)} disabled={removeLoading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmRemoveAccount} disabled={removeLoading}>
            {removeLoading ? (
              <><Spinner size="sm" animation="border" className="me-2" />Processing...</>
            ) : (
              "Yes, Remove Account"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* /Mobile Menu */}
      <style jsx>{`
        .profile-dropdown-card {
          background: #fff;
          border-radius: 16px;
        }
        @media (max-width: 991.98px) {
          .header {
            height: 56px;
            overflow: visible;
          }
          .header .header-left {
            height: 56px;
            padding: 0 10px;
          }
          .header .bar-icon {
            margin-top: 0;
          }
        }
        .profile-card-hero {
          background: linear-gradient(130deg, #f5f8ff, #ffffff);
          border-radius: 14px;
          padding: 1rem;
          position: relative;
        }
        .profile-avatar-wrapper {
          position: relative;
          display: inline-flex;
        }
        .status-dot {
          position: absolute;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #22c55e;
          border: 2px solid #fff;
          right: 4px;
          bottom: 2px;
        }
        .profile-role-badge {
          font-size: 0.65rem;
          letter-spacing: 0.05em;
          background: rgba(13, 110, 253, 0.1);
          color: #0d6efd;
          padding: 0.15rem 0.5rem;
          border-radius: 999px;
        }
        .status-pill {
          font-size: 0.75rem;
          padding: 0.2rem 0.65rem;
          border-radius: 999px;
          background: rgba(25, 135, 84, 0.12);
          color: #198754;
          font-weight: 600;
        }
        .status-pill--alert {
          background: rgba(220, 53, 69, 0.15);
          color: #dc3545;
        }
        .profile-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
          gap: 0.75rem;
        }
        .profile-info-item {
          border-radius: 12px;
          padding: 0.75rem;
          border: 1px solid #eef0f4;
          background: #f8f9fb;
        }
        .profile-contact-block {
          border-radius: 12px;
          border: 1px dashed #cfd6ff;
          background: #f5f7ff;
          padding: 0.85rem 1rem;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
        }
        .profile-contact-item {
          display: flex;
          align-items: center;
          font-size: 0.9rem;
          color: #495057;
        }
        .profile-contact-item i {
          color: #6c63ff;
        }
        .profile-card-action .btn {
          border-radius: 999px;
        }
        .profile-dropdown-card--mobile .profile-card-hero {
          padding: 0.85rem;
        }
        @media (max-width: 768px) {
          .dropdown-menu.dropdown-menu-end {
            min-width: 280px !important;
            max-width: 90vw !important;
            margin-left: -10px !important;
          }
          .dropdown-item {
            font-size: 0.95rem !important;
            padding: 0.75rem 1rem !important;
          }
          .avatar.avatar-md {
            width: 55px !important;
            height: 55px !important;
          }
          .fs-5 {
            font-size: 1.2rem !important;
          }
          .fs-4 {
            font-size: 1.3rem !important;
          }
          .profile-info-grid {
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          }
          .profile-card-action {
            width: 100%;
            text-align: left;
          }
          .profile-card-action .btn {
            width: 100%;
          }
        }
        .dropdown-item:hover {
          background-color: #f8f9fa !important;
          border-left-color: #007bff !important;
        }
        .dropdown-item i {
          color: #6c757d;
          transition: color 0.2s ease;
        }
        .dropdown-item:hover i {
          color: #007bff;
        }
        .account-switch-entry {
          position: relative;
        }
        .account-switch-dropdown {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          width: 260px;
          padding: 0.75rem;
          z-index: 1060;
        }
        .account-switch-list {
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          max-height: 260px;
          overflow-y: auto;
        }
        .account-switch-option {
          border: 1px solid #e9ecef;
          border-radius: 10px;
          background: #f8f9fb;
          padding: 0.45rem 0.65rem;
          transition: all 0.2s ease;
        }
        .account-switch-option:hover {
          border-color: #0d6efd;
          background: rgba(13, 110, 253, 0.05);
        }
        .account-switch-option.active {
          border-color: #0d6efd;
          background: rgba(13, 110, 253, 0.12);
        }
        .notification-bell-btn {
          position: relative;
          overflow: visible;
        }
        .notification-bell-icon-wrap {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .notification-bell-dot {
          position: absolute;
          top: -4px;
          right: -4px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #dc3545;
          box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
          animation: notificationPulse 1.2s infinite;
        }
        @keyframes notificationPulse {
          0% {
            box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
            transform: scale(1);
          }
          70% {
            box-shadow: 0 0 0 8px rgba(220, 53, 69, 0);
            transform: scale(1.08);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}

export default SidebarHeader